import { render, staticRenderFns } from "./AllActionLogs.vue?vue&type=template&id=6068b8bf&"
import script from "./AllActionLogs.vue?vue&type=script&lang=ts&"
export * from "./AllActionLogs.vue?vue&type=script&lang=ts&"
import style0 from "./AllActionLogs.vue?vue&type=style&index=0&id=6068b8bf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports